module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Kitchenaid-3d93953ec83383c86054eb285a04446d.png";